module.exports = __webpack_public_path__ + "static/fixaflash_lotus_logo-a430583c88a2197851e0f63aba65b5c8.svg";